import { render } from "./ToastSystem.vue?vue&type=template&id=45c138dd&ts=true"
import script from "./ToastSystem.vue?vue&type=script&lang=ts"
export * from "./ToastSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__